import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["completedCheckbox"]
  }

  confirmOverwrite(event) {
    const checked = this.completedCheckboxTargets.filter(cb => cb.checked)
    if (checked.length === 0) return

    const count = checked.length
    const message = count === 1
      ? "1 sample already has a kit registration number. Applying will overwrite it. Continue?"
      : `${count} samples already have kit registration numbers. Applying will overwrite them. Continue?`

    if (!window.confirm(message)) {
      event.preventDefault()
    }
  }
}
